import { endOfDay, endOfMonth, endOfQuarter, endOfWeek, endOfYear, format, formatISO, startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear, subDays, subMonths, subQuarters, subWeeks, subYears } from 'date-fns';
export default class DateHelper {
    /**
     * Returns standard date ranges
     *
     * @returns
     */
    static getStandardDateRanges() {
        const today = new Date();
        const todayStart = startOfDay(today);
        const todayEnd = endOfDay(today);
        const yesterday = subDays(today, 1);
        const yesterdayStart = startOfDay(yesterday);
        const yesterdayEnd = endOfDay(yesterday);
        const thisWeekStart = startOfWeek(today, { weekStartsOn: 1 });
        const thisWeekEnd = endOfWeek(today, { weekStartsOn: 1 });
        const lastWeekStart = subWeeks(thisWeekStart, 1);
        const lastWeekEnd = subWeeks(thisWeekEnd, 1);
        const last7DaysStart = subDays(todayStart, 6);
        const last7DaysEnd = new Date(formatISO(todayEnd));
        const thisMonthStart = startOfMonth(today);
        const thisMonthEnd = endOfMonth(today);
        const lastMonthStart = subMonths(thisMonthStart, 1);
        const lastMonthEnd = subMonths(thisMonthEnd, 1);
        const last30DaysStart = subDays(todayStart, 29);
        const last30DaysEnd = new Date(formatISO(todayEnd));
        const thisQuarterStart = startOfQuarter(today);
        const thisQuarterEnd = endOfQuarter(today);
        const lastQuarterStart = subQuarters(thisQuarterStart, 1);
        const lastQuarterEnd = subQuarters(thisQuarterEnd, 1);
        const thisYearStart = startOfYear(today);
        const thisYearEnd = endOfYear(today);
        const lastYearStart = subYears(thisYearStart, 1);
        const lastYearEnd = subYears(thisYearEnd, 1);
        return {
            'today': [format(todayStart, 'yyyy-MM-dd'), format(todayEnd, 'yyyy-MM-dd')],
            'yesterday': [format(yesterdayStart, 'yyyy-MM-dd'), format(yesterdayEnd, 'yyyy-MM-dd')],
            'this-week': [format(thisWeekStart, 'yyyy-MM-dd'), format(thisWeekEnd, 'yyyy-MM-dd')],
            'last-week': [format(lastWeekStart, 'yyyy-MM-dd'), format(lastWeekEnd, 'yyyy-MM-dd')],
            'last-7-days': [format(last7DaysStart, 'yyyy-MM-dd'), format(last7DaysEnd, 'yyyy-MM-dd')],
            'this-month': [format(thisMonthStart, 'yyyy-MM-dd'), format(thisMonthEnd, 'yyyy-MM-dd')],
            'last-month': [format(lastMonthStart, 'yyyy-MM-dd'), format(lastMonthEnd, 'yyyy-MM-dd')],
            'last-30-days': [format(last30DaysStart, 'yyyy-MM-dd'), format(last30DaysEnd, 'yyyy-MM-dd')],
            'this-quarter': [format(thisQuarterStart, 'yyyy-MM-dd'), format(thisQuarterEnd, 'yyyy-MM-dd')],
            'last-quarter': [format(lastQuarterStart, 'yyyy-MM-dd'), format(lastQuarterEnd, 'yyyy-MM-dd')],
            'this-year': [format(thisYearStart, 'yyyy-MM-dd'), format(thisYearEnd, 'yyyy-MM-dd')],
            'last-year': [format(lastYearStart, 'yyyy-MM-dd'), format(lastYearEnd, 'yyyy-MM-dd')],
        };
    }
}
//# sourceMappingURL=date-helper.js.map